import './SessionTimeoutModal.css';

const SessionTimeoutModal = ({ type, onContinue, onLogout }) => {
	 const handleLogin = () => {
    // Redirect to SSO login
    window.location.href = '/auth/login';
  };
  if (type === 'warning') {
    return (
      <div className="session-modal-overlay">
        <div className="session-modal">
          <h2 className="session-modal-title">Session Timeout</h2>
          <p className="session-modal-message">
            You're being timed out due to inactivity. Please choose to continue or to log out.
          </p>
          <div className="session-modal-buttons">
            <button className="session-modal-btn secondary" onClick={onLogout}>
              Log Out
            </button>
            <button className="session-modal-btn primary" onClick={onContinue}>
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'expired') {
    return (
      <div className="session-modal-overlay">
        <div className="session-modal">
          <h2 className="session-modal-title">Session Expired</h2>
          <p className="session-modal-message">
            Your logged session has been expired, please log in again.
          </p>
          <div className="session-modal-buttons">
            <button className="session-modal-btn primary" onClick={handleLogin}>
              Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SessionTimeoutModal;
